import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { AddStageToPipelineInput } from '@/gql/graphql';
import { v4 as uuid } from 'uuid';
import { createDraftPipelineMutation } from './createDraftPipelineMutation';
import draftMutationKeys from './keyFactory';
import { applyOptimisticAddStage } from './optimisticUpdates';

const ADD_STAGE_TO_PIPELINE_MUTATION = graphql(`
  mutation AddStageToPipeline($input: AddStageToPipelineInput!) {
    addStageToPipeline(input: $input) {
      id
      publicId
      title
      index
      colour
    }
  }
`);

const useDraftAddStageToPipeline = createDraftPipelineMutation<{
  publicId: string;
}>()({
  mutationKey: draftMutationKeys.addStageToPipeline,
  mutationFn: (input: AddStageToPipelineInput) => {
    return gqlClient.request(ADD_STAGE_TO_PIPELINE_MUTATION, { input });
  },
  applyOptimisticUpdate: (data, variables, { publicId }) =>
    applyOptimisticAddStage(data, variables, publicId),
  onBeforeOptimisticUpdate: (variables) => {
    const publicId = variables.publicId ?? uuid();
    // Mutate variables to include publicId so the mutation sends it to the server
    variables.publicId = publicId;
    return { publicId };
  },
});

export default useDraftAddStageToPipeline;
